/* eslint-disable no-unused-vars */

import { Dispatch, SetStateAction, useState } from 'react';

import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';

import { Button, Flexed } from '../../styles/GlobalComponents';
import { color, colors, lightTheme } from '../../styles/GlobalStyles';
import { BoxBig, CardStatus, HubImage, Td, Tr } from './Portfolio.styled';

import moment from 'moment';

import {
  LP,
  calculateNFTWithdrawalTime,
  formatUSD,
  formatUSDNoDecimals,
  walletsNFTWithdraw
} from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';

import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

import Spinner from '../../components/common/Spinner';
import {
  setConversionUserPackageId,
  toggleConversionModal
} from '../../slices/portfolio-slice';
import { UserPackage } from './Portfolio.types';
import { PortfolioItemDisabled } from './PortfolioItemDisabled';

import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { WithdrawStepsEnum } from './WithdrawHubs/types';

import { useDisconnect } from 'wagmi';
import { WithdrawalItemDisabled } from './WithdrawalItemDisabled';
import { TextWithTooltip } from '../../components/common/TextWithTooltip';
import { RedeemFlipmeCards } from './RedeemFlipmeCards/RedeemFlipmeCards';
import { RedeemFlipmeCardsStepsEnum } from './RedeemFlipmeCards/types';
import {
  ConnectWallet,
  ConnectWalletStatus
} from '../FlipMeWallet/FlipMeBanner';

interface PortfolioGamingProps {
  item: UserPackage;
  withdrawModal: boolean;
  setWithdrawModal: Dispatch<SetStateAction<boolean>>;
  setSelectedNFTWallet: any;
  setPackageItem: Dispatch<SetStateAction<UserPackage | null>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  transferAssetStatus: boolean;
  isFlipme?: boolean;
}

export const PortfolioGamingItem = ({
  item,
  withdrawModal,
  setWithdrawModal,
  setSelectedNFTWallet,
  setPackageItem,
  setIsOpen,
  transferAssetStatus,
  isFlipme
}: PortfolioGamingProps) => {
  const [redeemCardsModal, setRedeemCardsModal] = useState(false);

  const { flipMeStatus, isPersonalFlipmeRedeemRequired } = useAppSelector(
    (state) => state.wallets
  );

  const [redeemFlipmeCardsStep, setRedeemFlipmeCardsStep] =
    useState<RedeemFlipmeCardsStepsEnum>(RedeemFlipmeCardsStepsEnum.STEP1);

  const dispatch = useAppDispatch();

  const { disconnect } = useDisconnect();

  const { t } = useTranslation('my_hubs');

  const showDisabledGamingHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();
      const hours = fromNow.hours();

      if (days === 0 && hours < 24) {
        return (
          <PortfolioItemDisabled
            title={t('disabled_hub_title')}
            subtitle='It may take up to 24 Hours for Hub NFT to Refresh.'
          />
        );
      }
    }
  };

  const showConvertedHub = (item: any) => {
    if (item?.dateConverted) {
      return (
        <PortfolioItemDisabled
          title={'You Have Converted this Hub NFT into Loyalty Points'}
          subtitle={
            <>
              Date of conversion:{' '}
              {moment.utc(item?.dateConverted).format('MMM DD, yyyy')} <br />{' '}
              Loyalty Points Received: {formatUSD(item?.loyaltyPoints)} {LP}
            </>
          }
        />
      );
    }
  };

  const showDetailsText = (id: number) => {
    if (id < 50) {
      return t('gaming_hub_details');
    } else if (id >= 50 && id < 180) {
      return t('payment_hub_details');
    } else if (id >= 180 && id < 204) {
      return 'FlipMe card details';
    }
  };

  const showWithdrawableGamingHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();

      if (days > 0) {
        return <WithdrawalItemDisabled />;
      }
    }
  };

  const showWithdrawNFTButton = (item: any) => {
    if (item?.isWithdrawable && !item?.dateConverted && item?.nftId !== null) {
      return <Flexed column alignEnd></Flexed>;
    } else {
      return (
        calculateNFTWithdrawalTime(item) && (
          <Flexed column alignEnd>
            <Button
              color='#ffffff'
              borderColor='#CC0000'
              background='#CC0000'
              wSM='100%'
              w='200px'
              onClick={() => {}}
              negative={false}>
              TRANSFERRED
            </Button>
          </Flexed>
        )
      );
    }
  };

  const cardStatuses = (status: string) => {
    if (status === 'error') {
      return colors.error500;
    } else if (status === 'redeemed') {
      return colors.success500;
    } else {
      return colors.warning;
    }
  };

  const showToolTipCards = (item: any) => {
    const cards = item.flipmeCards.map((card: any, index: number) => {
      return (
        <div key={index}>
          <CaptionText>Wallet Address: {card.walletAddress}</CaptionText>
          <CaptionText>
            Status:{' '}
            <span
              style={{
                color: cardStatuses(card.status)
              }}>
              {card.status}
            </span>
          </CaptionText>
          {card.errorMessage && (
            <CaptionText>
              Error Message:{' '}
              <span
                style={{
                  color: cardStatuses(card.status)
                }}>
                {card.errorMessage}
              </span>
            </CaptionText>
          )}
        </div>
      );
    });
    return cards;
  };

  return (
    <>
      <BoxBig relative>
        <HubImage
          image={item?.image}
          isDisabled={calculateNFTWithdrawalTime(item)}>
          <H4 color={color.colors.neutral0}>{item?.name}</H4>
        </HubImage>
        <div>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>

          <>
            <Tr style={{ cursor: 'pointer' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText
                  caps
                  bold
                  color={color.colors.neutral500}
                  mb='10'
                  mr='15'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {formatUSDNoDecimals(item?.price)} <P3 mb='1'>USDT</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {item.packageId < 180 && t('revenue_share_points')}
                </CaptionText>
                {item.packageId < 180 && (
                  <P1 bold flex alignEnd gap='5px'>
                    {formatUSD(item?.rsp)} <P3 mb='1'>RSP</P3>
                  </P1>
                )}
                {item.packageId > 179 && (
                  <Button
                    wSM='100%'
                    w='200px'
                    disabled={item?.flipmeCardsRemaining === 0}
                    onClick={() => {
                      if (flipMeStatus !== ConnectWalletStatus.CONNECTED) {
                        setIsOpen(true);
                      } else if (isPersonalFlipmeRedeemRequired) {
                        setRedeemCardsModal(true);
                        setRedeemFlipmeCardsStep(
                          RedeemFlipmeCardsStepsEnum.STEP1
                        );
                        setPackageItem(item);
                      } else {
                        setRedeemCardsModal(true);
                        setRedeemFlipmeCardsStep(
                          RedeemFlipmeCardsStepsEnum.STEP2
                        );
                        setPackageItem(item);
                      }
                    }}
                    mb='10'>
                    Activate
                  </Button>
                )}
              </Td>
              <Td w='20%' wSM='50%'>
                {item?.flipmeCardsRemaining + item?.flipmeCards?.length > 1 && (
                  <>
                    <CaptionText
                      caps
                      bold
                      color={color.colors.neutral500}
                      mb='10'
                      ml='35'>
                      {item.packageId > 179 && 'REMAINING'}
                    </CaptionText>
                    <P1 bold flex alignEnd gap='5px' ml='35'>
                      {item?.flipmeCardsRemaining}
                    </P1>
                  </>
                )}
              </Td>
              <Td w='20%' wSM='50%'>
                {item.packageId > 179 ? (
                  <>
                    {' '}
                    <CaptionText
                      caps
                      bold
                      color={color.colors.neutral500}
                      mb='10'
                      ml='10'>
                      ACTIVE
                      {item?.flipmeCards?.length > 0 && (
                        <TextWithTooltip
                          margin='30px 0 8px 0'
                          tooltip={showToolTipCards(item)}
                          width='auto'
                          column='column'
                        />
                      )}
                    </CaptionText>
                    <P1 bold flex alignEnd gap='5px' ml='10'>
                      {item?.flipmeCards?.length}
                    </P1>
                  </>
                ) : (
                  showWithdrawNFTButton(item)
                )}
              </Td>
            </Tr>
          </>

          <div>
            <>
              <Responsive style={{ margin: '24px 0' }} between>
                <Flexed mbSM='20' rowSM gap='20px'>
                  <P3 caps bold color={color.colors.secondary100}>
                    {showDetailsText(item?.packageId)}
                  </P3>
                  <P3 flex color={color.colors.secondary100}>
                    {t('order_id')}:{' '}
                    <P3 bold color={color.colors.secondary100}>
                      {item?.id}
                    </P3>
                  </P3>

                  <P3 flex color={color.colors.secondary100}>
                    {item?.packageId < 180 ? t('nft_id') : 'PACKAGE ID'}:
                    <P3 bold color={color.colors.secondary100}>
                      {item.packageId < 180 ? item?.nftId : item?.packageId}
                    </P3>
                  </P3>
                </Flexed>
              </Responsive>
            </>
          </div>
          {item?.isConvertable && (
            <div>
              <P2 mt='20'>
                Potential Loyalty Points:{' '}
                <b>
                  {formatUSD(item?.potentialLoyaltyPoints)} {LP}
                </b>
              </P2>
              {item?.isWithdrawable && !item?.dateConverted && (
                <Button
                  mt='10'
                  w='250px'
                  negative
                  textColor={lightTheme.colors.primary900}
                  onClick={() => {
                    dispatch(toggleConversionModal(true));
                    dispatch(setConversionUserPackageId(item.id));
                  }}>
                  CONVERT TO LOYALTY POINTS
                </Button>
              )}
            </div>
          )}
        </div>

        {showConvertedHub(item)}
        {calculateNFTWithdrawalTime(item)
          ? showWithdrawableGamingHub(item)
          : showDisabledGamingHub(item)}
      </BoxBig>

      <RedeemFlipmeCards
        redeemCardsModal={redeemCardsModal}
        setRedeemCardsModal={setRedeemCardsModal}
        redeemFlipmeCardsStep={redeemFlipmeCardsStep}
        setRedeemFlipmeCardsStep={setRedeemFlipmeCardsStep}
        packageId={item?.id}
      />
    </>
  );
};
